import { AbstractDataProviderV2 } from 'components/system/data-provider';
import { CustomerBuddyAdd, RsCustomerBuddy, RsCustomerBuddyInfo } from './types';

export class CustomerBuddiesDataProvider extends AbstractDataProviderV2<RsCustomerBuddy, RsCustomerBuddyInfo, CustomerBuddyAdd> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/buddies');
    }

    update(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
